import request from '@/utils/request'

// 财务交易汇总
export function finacialList(type, date) {
  const url = (type === 'month') ? '/business-log/get-month-statistics-list' : '/business-log/get-day-statistics-list'
  return request({
    url: url,
    method: 'get',
    params: { date: date }
  })
}
// 财务交易明细
export function finacialDetail(req) {
  return request({
    url: '/business-log/get-day-detail-list',
    method: 'get',
    params: req
  })
}
